import type CreativeSDK from '@cesdk/cesdk-js';

/**
 * IMG.LY reads this metadata key off exported blocks to see what an export is actually made of -
 * a customer upload dropped straight onto a garment, or something built in the editor.
 *
 * The defaultApply... implementations clear the key so stale labels can't linger, so it always has
 * to be set after the default call has resolved.
 */
export const customExportMetadataKey = 'ly.img.custom_export_metadata';

/**
 * Labels name where content came from, never what it costs - IMG.LY maps them to price tiers on
 * their side, so a tier change needs no release from us. They have to be namespaced and stable,
 * and agreed with IMG.LY first: an unknown label is billed at the standard rate.
 *
 * The engine allows at most 16 distinct labels per export and 64 bytes per label.
 */
export enum ExportLabel {
	//Artwork the customer supplied, whether uploaded just now or picked back out of their library
	Upload = 'com.theprintbar.user_upload',
	//One of our shapes
	Shape = 'com.theprintbar.shape',
	Text = 'com.theprintbar.text',
	TeamName = 'com.theprintbar.team_name',
	//Blocks we add to the scene ourselves as editing aids - exclusion zones, snap line margins,
	//the garment mockup - never anything the customer put there, and never printed
	Gizmo = 'com.theprintbar.gizmo',
}

export function setExportLabel(editor: CreativeSDK | null, block: number | undefined | null, label: ExportLabel) {
	if (!editor || block == null) return block;
	try {
		editor.engine.block.setMetadata(block, customExportMetadataKey, label);
	} catch (e) {
		//Labelling is only for IMG.LY's reporting, it should never break placing an asset
		console.error('Failed to set export label', e);
	}
	return block;
}
